import React from 'react'
import PropTypes from 'prop-types'
import { View, StyleSheet, Image } from 'react-native'
import Particles from 'react-particles-js'
import ParticlesConfig from '../../../utils/particles.js'

import Assets from '../../../../assets/export'
import { IconButton } from '../../../components'
import { useTheme } from '../../../theming/ThemeProvider'
import { usePlatforms } from '../../../hooks/usePlatforms'
import { LoginWrapperComponent } from './styles'
import AuthCarousel from './AuthCarousel.js'

const AuthContainer = ({ onNavigateBack, children }) => {
  const { isTablet, isDesktop } = usePlatforms()
  const { theme } = useTheme()

  const styles = useStyles(theme, isTablet, isDesktop)

  return (
    <LoginWrapperComponent style={{ height: '100%' }}>
      <Particles
        className={`Login-particles ${!isTablet ? 'Login-particles--mobile' : ''}`}
        params={ParticlesConfig}
      />
      <View style={styles.background}>
        <View style={[styles.information, !isTablet && styles.viewMobile]}>
          {isDesktop && <AuthCarousel />}
          <View style={styles.logo}>
            <Image source={Assets.logoLight} style={styles.image} resizeMode='contain' />
          </View>
        </View>
        <View style={[styles.view, !isTablet && styles.viewMobile]}>
          <View style={styles.help}>
            {Boolean(onNavigateBack) && (
              <IconButton
                icon='LeftArrow'
                onPress={onNavigateBack}
                color={isTablet ? 'GALLERY' : 'CATSKILL_WHITE'}
                iconColor={isTablet ? 'SLATE_GRAY_TEXT' : 'BUNKER'}
                size={30}
                iconSize={16}
                testID='authLayoutGoBackButton'
                accessibilityLabel='authLayoutGoBackButton'
              />
            )}
          </View>
          {children}
        </View>
      </View>
    </LoginWrapperComponent>
  )
}

const useStyles = (theme, isTablet, isDesktop) => StyleSheet.create({
  background: {
    width: '100%',
    height: '100%',
    flexDirection: isTablet ? 'row' : 'column',
    justifyContent: 'space-between'
  },
  information: {
    width: '100%',
    maxWidth: isTablet ? '60%' : '100%',
    padding: 50,
    height: '100%',
    alignItems: isDesktop ? 'flex-start' : 'center',
    justifyContent: isDesktop ? 'space-between' : 'center',
    paddingTop: 50
  },
  informationMobile: {
    flex: 1
  },
  logo: {
    width: isDesktop ? 'auto' : '100%',
    maxWidth: isDesktop ? 'auto' : '100%',
    justifyContent: isDesktop ? 'flex-start' : 'center',
    alignItems: 'center',
    marginLeft: isDesktop ? 35 : 0
  },
  image: {
    width: isTablet ? 300 : 180,
    height: isTablet ? 67 : 40
  },
  view: {
    width: '100%',
    maxWidth: isTablet ? '40%' : '100%',
    height: '100%',
    padding: isDesktop ? 80 : isTablet ? 40 : 0,
    backgroundColor: isTablet ? theme.WHITE : 'transparent'
  },
  viewMobile: {
    flex: 1
  },
  help: {
    padding: isTablet ? 0 : 20,
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingTop: isTablet ? 0 : 40
  }
})

AuthContainer.propTypes = {
  onNavigateBack: PropTypes.func,
  children: PropTypes.node.isRequired
}

export default AuthContainer
